import Organization from 'entities/organization/model';

import { STORE, CLEAR, UPDATE_ORGANIZATION, UPDATE_PROPERTY } from './constants';
import User from './model';

export interface StoreUserAction {
  type: typeof STORE;
}
export const storeAction = (user: User, properties = []) => ({
  type: STORE,
  user,
  properties,
});

export const clearAction = () => ({ type: CLEAR });

export const updateOrganizationAction = (organization: Organization) => ({
  type: UPDATE_ORGANIZATION,
  organization,
});

export const updatePropertyAction = (property: string[], value: unknown) => ({
  type: UPDATE_PROPERTY,
  property,
  value,
});
